import * as actionTypes from '../actionTypes';

const state = {
  isSurveyFormEditSavedNotYet: false,
  isIndexPageEditSavedNotYet: false,
  isBadgeEditSavedNotYet: false,
};

function IsSavedNotYetReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_IS_SURVEY_FORM_EDIT_SAVED_NOT_YET:
      return {
        ...globalState,
        isSurveyFormEditSavedNotYet: action.toggle,
      };
    case actionTypes.SET_IS_INDEX_PAGE_EDIT_SAVED_NOT_YET:
      return {
        ...globalState,
        isIndexPageEditSavedNotYet: action.toggle,
      };
    case actionTypes.SET_IS_BADGE_EDIT_SAVED_NOT_YET:
      return {
        ...globalState,
        isBadgeEditSavedNotYet: action.toggle,
      };
    default:
      return globalState;
  }
}
export { IsSavedNotYetReducer as default };
